import * as React from "react";
import { useNotify } from "react-admin";
import {
  Box, Card, CardContent, Typography, TextField, Button, Tabs, Tab,
  CircularProgress, Alert, Table, TableHead, TableBody, TableRow, TableCell,
  IconButton, Tooltip,
} from "@mui/material";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { httpClient } from "../../api/httpClient";
import { API_BASE_URL } from "../../api/config";

const TABS = [
  { key: "accepted", label: "Acceptées", path: "accepted" },
  { key: "incoming", label: "Demandes reçues", path: "incoming" },
  { key: "outgoing", label: "Demandes envoyées", path: "outgoing" },
];

const Friendships = () => {
  const [patientId, setPatientId] = React.useState("");
  const [tab, setTab] = React.useState(0);
  const [list, setList] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const notify = useNotify();

  const fetchList = async (tabIdx = tab) => {
    if (!patientId.trim()) return;
    setLoading(true);
    try {
      const { json } = await httpClient(
        `${API_BASE_URL}/patients/${patientId}/friends/${TABS[tabIdx].path}`
      );
      setList(Array.isArray(json) ? json : json?.data || []);
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
      setList([]);
    } finally {
      setLoading(false);
    }
  };

  const action = async (friendshipId, kind) => {
    try {
      const url = kind === "delete"
        ? `${API_BASE_URL}/patients/${patientId}/friends/${friendshipId}`
        : `${API_BASE_URL}/patients/${patientId}/friends/${friendshipId}/${kind}`;
      await httpClient(url, { method: kind === "delete" ? "DELETE" : "POST" });
      notify("Action effectuée", { type: "success" });
      fetchList();
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <ConnectWithoutContactIcon /> Connexions patient
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Liste les amis acceptés / demandes en cours d'un patient et permet d'agir dessus.
      </Alert>
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Box sx={{ display: "flex", gap: 1 }}>
            <TextField size="small" label="ID patient" value={patientId}
              onChange={(e) => setPatientId(e.target.value)} />
            <Button variant="contained" onClick={() => fetchList()}
              disabled={loading || !patientId.trim()}>
              {loading ? <CircularProgress size={18} /> : "Charger"}
            </Button>
          </Box>
          <Tabs value={tab} onChange={(_, v) => { setTab(v); fetchList(v); }} sx={{ mt: 2 }}>
            {TABS.map((t) => <Tab key={t.key} label={t.label} />)}
          </Tabs>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Ami / Cible</TableCell>
                <TableCell>Statut</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.length === 0 ? (
                <TableRow><TableCell colSpan={4} align="center">Aucune connexion</TableCell></TableRow>
              ) : list.map((f, i) => (
                <TableRow key={f.id || i}>
                  <TableCell>{f.id}</TableCell>
                  <TableCell>{f.friendId || f.targetId} {f.friendName || ""}</TableCell>
                  <TableCell>{f.status}</TableCell>
                  <TableCell align="right">
                    {tab === 1 && (
                      <>
                        <Tooltip title="Accepter">
                          <IconButton size="small" color="success"
                            onClick={() => action(f.id, "accept")}>
                            <CheckIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Refuser">
                          <IconButton size="small" color="warning"
                            onClick={() => action(f.id, "decline")}>
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                    <Tooltip title="Supprimer">
                      <IconButton size="small" color="error"
                        onClick={() => action(f.id, "delete")}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </Box>
  );
};

export default { list: Friendships };
